module.exports = __webpack_public_path__ + "static/media/eng_ep.8669620d.jpg";